<template>
  <div class="d-flex my-3">
    <div class="text-h4 font-bold">
      <slot></slot>
    </div>
    <div v-if="hasHelpContent" class="ml-1">
      <help-dialog ref="helpDialog" :data="helpInfo" />
    </div>
  </div>
</template>
<script>
import HelpDialog from "@/components/helpDialog.vue";

export default {
  name: "heading",
  components: { HelpDialog },
  props: ["helpInfo"],
  data: () => ({}),
  computed: {
    hasHelpContent() {
      const h = this.helpInfo;
      if (!h) return false;
      const hasText = (v) => typeof v === "string" && v.trim().length > 0;
      return (
        hasText(h.subtitle) ||
        hasText(h.description) ||
        hasText(h.youtubeUrl) ||
        hasText(h.supportUrl) ||
        (Array.isArray(h.downloadButtons) && h.downloadButtons.length > 0)
      );
    },
  },
};
</script>
